import React, { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetAll, onResend, onSendEmails } from 'redux/actions/proceduresEmails.actions';
import { proceduresEmailsSelector } from 'redux/selectors/proceduresEmails.selector';

import LayoutContainer from 'containers/LayoutContainer';
import ProceduresEmailsView from 'views/ProceduresEmailsView';
import ActionButtons from 'components/commons/Table/components/ActionButtons';

import { ITableUpdate } from 'components/commons/Table/types';

import 'views/ProceduresEmailsView/i18n';

const ProceduresEmailsContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { count, loading, table } = useTypedSelector((state) => state.proceduresEmails);
  const items = useTypedSelector(proceduresEmailsSelector);

  const actions = [
    {
      label: i18next.t<string>('PROCEDURES_EMAILS_VIEW:RESEND'),
      onClick: (id: string) => dispatch(onResend(id)),
    },
  ];

  const columns = [
    {
      name: 'procedureName',
      label: i18next.t<string>('PROCEDURES_EMAILS_VIEW:PROCEDURE_NAME'),
    },
    {
      name: 'email',
      label: i18next.t<string>('PROCEDURES_EMAILS_VIEW:EMAIL'),
    },
    {
      name: 'id',
      label: i18next.t<string>('PROCEDURES_EMAILS_VIEW:ACTIONS'),
      options: {
        customBodyRender: (value: string) => <ActionButtons id={value} items={actions} />,
        sort: false,
      },
    },
  ];

  const onTableUpdate = useCallback((data: ITableUpdate) => dispatch(onGetAll(data)), [dispatch]);

  return (
    <LayoutContainer auth title={i18next.t<string>('PROCEDURES_EMAILS_VIEW:TITLE')}>
      <ProceduresEmailsView
        columns={columns}
        count={count}
        data={items}
        loading={loading}
        onAddClick={() => dispatch(onSendEmails())}
        onTableUpdate={onTableUpdate}
        table={table}
      />
    </LayoutContainer>
  );
};

export default ProceduresEmailsContainer;
